import React from "react";
import Seo from "components/Seo";
import { useLocation, useNavigate } from "react-router-dom";
import CustomerLayout from "./customerLayout";
import { useGetRequestView } from "../../../../../hooks/morning/useGetRequestView";
import { useDeleteRequest } from "../../../../../hooks/morning/useDeleteRequest";
import Button from "../../-components/common/Button";
import { useState } from "react";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";

const MorningRequestEdit = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [showCompletePop, setShowCompletePop] = useState<boolean>(false);
    const { data } = useGetRequestView(state.listNo);
    const { mutate: deleteRequest } = useDeleteRequest(() => {
        navigate("/customer/invoices-edit");
    });

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="청구서수정요청" />
            <CustomerLayout>
                <div className="bg-[#f8f8f8] flex flex-col items-center pt-12 responsive1200:px-[4%] responsive1200:pt-[30px]">
                    <p className="text-[#1b1c1e] text-[36px] font-bold responsive1200:text-[24px] responsive1200:font-[500]">
                        청구서수정요청
                    </p>
                    <div className="bg-white mt-12 w-full max-w-[1200px] px-10 py-6 rounded-2xl flex flex-col mb-6 responsive1200:px-[4%] responsive1200:my-[30px] responsive450:py-[10%]">
                        <div className="text-[#333] w-full text-[15px] border-t-2 border-black mt-10 responsive450:mt-0">
                            <div className="flex items-center h-[48px] border-b responsive450:flex-col responsive450:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive450:w-full responsive450:border-r-0  responsive450:border-b">
                                    제목
                                </p>

                                <p className="px-5 responsive450:py-[10px]">{data?.subject}</p>
                            </div>
                            <div className="flex items-center h-[48px] border-b responsive450:flex-col responsive450:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive450:w-full responsive450:border-r-0  responsive450:border-b">
                                    운송장번호
                                </p>
                                <p className="px-5 responsive450:py-[10px]">{data?.bl_no}</p>
                            </div>
                            <div className="flex items-center h-[48px] border-b responsive450:flex-col responsive450:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive450:w-full responsive450:border-r-0  responsive450:border-b">
                                    요청업체명
                                </p>
                                <p className="px-5 responsive450:py-[10px]">{data?.company}</p>
                            </div>
                            <div className="flex  items-stretch min-h-[48px] border-b responsive450:flex-col responsive450:h-auto">
                                <p className="bg-[#f8f8f8]  border-r py-2 min-w-[165px] flex  items-center justify-center responsive450:w-full responsive450:border-r-0  responsive450:border-b">
                                    문의 및 요청사항
                                </p>
                                <div
                                    className="px-5 py-3 flex flex-col items-start justify-center space-y-2 responsive450:py-[10px]"
                                    dangerouslySetInnerHTML={{ __html: data?.contents || "" }}
                                />
                            </div>
                            <div className="flex items-center h-[48px] border-b responsive450:flex-col responsive450:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive450:w-full responsive450:border-r-0  responsive450:border-b">
                                    비고
                                </p>
                                <p className="px-5 responsive450:py-[10px]">{data?.bigo}</p>
                            </div>
                            <div className="flex items-center h-[48px] border-b responsive450:flex-col responsive450:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive450:w-full responsive450:border-r-0  responsive450:border-b">
                                    연락 드릴 번호
                                </p>
                                <p className="px-5 responsive450:py-[10px]">{data?.mobile}</p>
                            </div>
                        </div>
                        <div className="w-full text-white bg-[#4d5d81] p-3 text-center mt-10">답변</div>
                        {data?.comment_list.map((comment: any, index: number) => (
                            <div className="flex items-center py-[25px] pl-[25px] min-h-[30px] border-b gap-5">
                                <div className="bg-[#264180] rounded-full w-[30px] h-[30px] text-white flex items-center justify-center font-[500]">
                                    A
                                </div>
                                <p className="text-[#333] text-[15px]">{comment.c_content}</p>
                            </div>
                        ))}
                        <div className="flex text-[15px] justify-end w-full gap-1 mt-6 mb-12 responsive450:mb-0">
                            <button
                                onClick={() =>
                                    navigate("/customer/invoices-edit/register", { state: { data: data, listNo: state.listNo } })
                                }
                                className="w-[70px] h-[40px] border text-[#555] rounded-md"
                            >
                                수정
                            </button>
                            <button onClick={() => setShowCompletePop(true)} className="w-[70px] h-[40px] border text-[#555] rounded-md">
                                삭제
                            </button>
                            <button
                                onClick={() => navigate("/customer/invoices-edit")}
                                className="w-[70px] h-[40px] bg-[#264180] text-white rounded-md"
                            >
                                목록
                            </button>
                        </div>
                    </div>
                </div>
                {showCompletePop && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="absolute z-[100] mt-[34px] flex flex-col gap-8 bg-white border w-[560px] p-10 rounded-lg shadow-lg overflow-hidden">
                            <div className="text-2xl flex items-center justify-between">
                                <p>삭제하시겠습니까?</p>
                                <Close onClick={() => setShowCompletePop(false)} className="cursor-pointer" />
                            </div>
                            <div className="flex gap-2">
                                <Button onClick={() => setShowCompletePop(false)} className="w-full" size="L">
                                    취소
                                </Button>
                                <Button
                                    onClick={() => {
                                        deleteRequest({ list_no: state.listNo });
                                    }}
                                    className="w-full border-none bg-new text-white"
                                    size="L"
                                >
                                    확인
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </CustomerLayout>
        </React.Fragment>
    );
};

export default MorningRequestEdit;
